import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { logError } from "../lib/log";
import * as apiClient from "../api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useI18n();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = hash.includes("session_id=") ? hash.split("session_id=")[1].split("&")[0] : null;
    (async () => {
      if (!sessionId) { navigate("/accedi"); return; }
      try {
        const res = await apiClient.googleSession(sessionId);
        apiClient.setAccessToken(res.token);
        setUser(res.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { state: { user: res.user } });
      } catch (err) {
        logError("auth-callback", err);
        toast.error(t("common.error"));
        navigate("/accedi");
      }
    })();
  }, [navigate, setUser, t]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <Sparkles className="h-10 w-10 text-secondary animate-pulse" />
      <p className="mt-4 text-slate-500">Accesso in corso...</p>
    </div>
  );
}
